import {type PropsWithChildren} from 'react';
import {clsx} from 'clsx';
import {isContainerQueryAvailable} from '../lib/container-query-with-fallback';
import {useVersion} from '../context';
import {ImageListContextProvider} from './context';
import styles from './root.module.css';

type Props = PropsWithChildren<{
  readonly imagesLength: number;
}>;

export function ImageListRoot({children, imagesLength}: Props) {
  const version = useVersion();
  return (
    <ImageListContextProvider imagesLength={imagesLength}>
      <div
        id='js-press-release-image-list'
        className={clsx(
          styles.root,
          version === '2015' && styles.root2015,
          isContainerQueryAvailable() ? styles.pressReleaseRoot : styles.screen,
        )}
      >
        {children}
      </div>
    </ImageListContextProvider>
  );
}
